<template>
  <div v-html="content" class="content"></div>
</template>

<script>
import $ from "jquery";

export default {
  name: "stockguild",
  components: {},
  data() {
    return {
      content: "",
      linkList: [],
      linkList1: []
    };
  },
  methods: {
    

  
    getActivityDetail() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "active_activity",
            activityid: that.$route.query.activityid
          }
        })
        .then(ret => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.content = resData.data;
            that.content = that.content.replace("http://wonder.apps/recharge", "#/myaccount/capital");
            that.content = that.content.replace("http://wonder.apps/withdraw", "#/myaccount/capital");
            that.content = that.content.replace("http://wonder.apps/realname_auth", "#/myaccount/information");
            that.content = that.content.replace("http://wonder.apps/trading", "#/operate/operateday");
            that.content = that.content.replace("http://wonder.apps/register", "#/login/register");
            that.content = that.content.replace("http://wonder.apps/login", "#/login");
          } else {
            that.$alert("请稍后尝试", "提示", {
              confirmButtonText: "确定"
            });
          }
        });
    }
  },

  // },
  mounted: function() {
    let that = this;
    this.getActivityDetail();
  }
};

// $(document).ready(function() {
//     $("a").click(function() {
//       console.log("load anchor tag ",this);
//         //Do stuff when clicked
//     });
// });
</script>

<style scoped>
.content {
  margin: 0 auto;
  text-align: center;
}
.content >>> img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/stockguild.vue